import { Component, OnInit, OnDestroy } from "@angular/core";
import { DevicesService } from "./devices.service";
import { SessionStateService } from "../../core/services/session-state.service";
import { GeneralService } from "../../shared/services/general.service";
import { IotService } from "../../core/services/iot.service";

@Component({
  selector: "app-devices",
  templateUrl: "./devices.component.html",
  styleUrls: ["./devices.component.scss"],
})
export class DevicesComponent implements OnInit, OnDestroy {
  boxOn: boolean;
  loading: boolean;
  menu: String[];
  hasType = false;

  constructor(
    private sessionStateService: SessionStateService,
    private generalService: GeneralService,
    private devicesService: DevicesService,
    private iotService: IotService
  ) {}

  ngOnInit() {
    this.iotService.connect();
    this.loading = true;
    this.generalService
      .getBoxConnectionStatus()
      .flatMap((state) => {
        this.boxOn = state;
        return this.initComponent();
      })
      .finally(() => (this.loading = false))
      .subscribe();
    this.generalService.connChange.subscribe((state) => {
      this.boxOn = state;
      if (state) {
        this.loading = true;
        this.initComponent()
          .finally(() => (this.loading = false))
          .subscribe();
      }
    });
  }

  initComponent() {
    return this.devicesService
      .getHouseDeviceTypes(this.sessionStateService.getHouse().houseId)
      .map((types) => {
        this.menu = types;
      });
  }

  changeTab(event) {
    this.hasType = event;
  }

  getBoxConnectionStatus() {
    return this.boxOn;
  }

  ngOnDestroy() {
    //this.iotService.disconnect();
    this.generalService.initConnChange();
  }

  showCoachMark(type) {
    return this.sessionStateService.getCoachMarkIndividualState().get(type);
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/devices/devices.component.ts